import { useCurrentUser } from 'hooks/useCurrentUser';
import KnowledgeBank from 'pages/knowledge-bank/KnowledgeBank';

export default function MyKnowledgeBank({ match }) {
  const currentUser = useCurrentUser();
  const loggedInUserId = currentUser?.id;
  return <KnowledgeBank match={match} studentId={loggedInUserId} />;
}
